module.exports = __webpack_public_path__ + "static/images/kaiping2_f84dfe3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/posbannerblack/kaiping2.png
// module id = 240
// module chunks = 1